<div class="company-product-expected-vs-registered-details">
  <h4 class="details-title">Resumen</h4>

  @if (!detailData()) {
    <p class="no-data">Sin datos para este periodo.</p>
  } @else {
    @if (summary(); as totals) {
      <div class="summary-row">
        <span class="summary-label">Total registrado / esperado</span>
        <span class="summary-value">{{ totals.done | number: '1.1-1' }}h / {{ totals.expected | number: '1.1-1' }}h</span>
      </div>
      <div class="summary-row compliance">
        <span class="summary-label">Ajuste (sobre 100)</span>
        <span class="summary-value">{{ totals.compliance | number: '1.1-1' }}%</span>
      </div>
      <div class="summary-row deviation">
        <span class="summary-label">Desviación respecto a lo esperado</span>
        <span class="summary-value">{{ totals.deviation | number: '1.1-1' }}%</span>
      </div>
    }
  }
</div>
